export class CacheAssignedPatient {
     PatientId: number;
     PatientFirstName: string;
     PatientLastName: string;
     ServiceTypeID: number;
     ServiceTypeName: string;
     VisitDuration: number;
     PatientTime: string;
     PatientZone: number;
     SistemPatientID2: number;
     UnitCostRate: number;

    constructor(
         PatientId: number,
         PatientFirstName: string,
         PatientLastName: string,
         ServiceTypeID : number,
         ServiceTypeName: string,
         VisitDuration: number,
         PatientTime: string,
         PatientZone: number,
         SistemPatientID2: number,
         UnitCostRate: number 
        ) 
        {
            this.PatientId = PatientId;
            this.PatientFirstName = PatientFirstName;
            this.PatientLastName = PatientLastName;
            this.ServiceTypeID = ServiceTypeID;
            this.ServiceTypeName = ServiceTypeName;
            this.VisitDuration = VisitDuration;
            this.PatientTime = PatientTime;
            this.PatientZone = PatientZone;
            this.SistemPatientID2 = SistemPatientID2;
            this.UnitCostRate = UnitCostRate;
        }
}